import { SinglePaymentStatus } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '@/config/types';

export const getSinglePaymentStatusParams = (singlePaymentStatus: SinglePaymentStatus): StatusTagType => {
  switch (singlePaymentStatus) {
    case SinglePaymentStatus.CONFIRMED:
      return StatusTagType.SUCCESS;
    case SinglePaymentStatus.DENIED:
      return StatusTagType.ERROR;
    case SinglePaymentStatus.PENDING:
      return StatusTagType.WARNING;
    case SinglePaymentStatus.PROCESSING:
      return StatusTagType.INFO;
    default:
      return StatusTagType.DEFAULT;
  }
};
